/* eslint-disable no-console */
import type { SeverityLevel } from "@sentry/nextjs";
import { AxiosError } from "axios";

import { SentryErrorType } from "constants/enum";
import { reportToSentry } from "utils/reportToSentry";

export const handleApiError = (
    error: AxiosError<any>,
    withSentry?: boolean,
    level?: SeverityLevel
) => {
    if (error?.response) {
        const {
            data: responseData = {},
            status: responseStatus,
            headers,
            config,
        } = error.response;
        const {
            status: statusMessage = "",
            error: errorMessage = "",
            data = null,
        } = responseData as { status: number; error: string; data: any };

        console.warn(statusMessage, errorMessage, JSON.stringify(data));
        console.warn(responseStatus);
        console.warn(headers);

        const isInnerError = [
            process.env.API_URL_V2,
            process.env.API_URL_V3,
        ].includes(config?.baseURL);

        if (isInnerError && withSentry) {
            reportToSentry({
                error: data.error,
                extra: error.request || data.data,
                level: level || "fatal",
            });
        }

        return data;
    } else if (error?.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.warn(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.warn("Error", error.message);
    }

    if (withSentry) {
        reportToSentry({
            error: SentryErrorType.NO_RESPONSE,
            extra: { error },
            level: "info",
        });
    }
};

export const handleApiErrorWithSentry = (
    error: AxiosError,
    level?: SeverityLevel
) => {
    return handleApiError(error, true, level);
};

export const handleApiErrorWithSentryInfo = (error: AxiosError) => {
    return handleApiErrorWithSentry(error, "info");
};
